import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Initialize GA4 once
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const AnalyticsTracker = () => {
  const location = useLocation();

  // --- 1. Track Page Views ---
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
    });
  }, [location]);

  // --- 2. Track All Clicks ---
  useEffect(() => {
    const handleClick = (e) => {
      const el = e.target.closest("a, button, [data-track]");
      if (!el) return;

      ReactGA.event("click_event", {
        click_text: el.innerText || null,
        click_url: el.getAttribute("href") || null,
        click_id: el.id || null,
        click_classes: el.className || null,
        page_location: window.location.pathname,
      });
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  // --- 3. Track Time on Page (heartbeat) ---
  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const seconds = Math.round((Date.now() - start) / 1000);
      ReactGA.event("time_on_page", {
        time_spent_seconds: seconds,
        page_location: window.location.pathname,
      });
    }, 15000); // every 15s

    return () => clearInterval(interval);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
